export const documentation = {
  junior: [
    { name: 'QA Testing Standards', url: '/docs/qa-testing-standards', type: 'standards' },
    { name: 'Test Case Writing Guidelines', url: '/docs/test-case-guidelines', type: 'process' },
    { name: 'Bug Reporting Best Practices', url: '/docs/bug-reporting', type: 'process' },
    { name: 'Test Environment Setup', url: '/docs/test-environment-setup', type: 'environment' },
    { name: 'Regression Testing Process', url: '/docs/regression-testing', type: 'testing' }
  ],
  mid: [
    { name: 'Test Automation Framework', url: '/docs/test-automation-framework', type: 'automation' },
    { name: 'Performance Testing Guidelines', url: '/docs/performance-testing', type: 'performance' },
    { name: 'API Testing Standards', url: '/docs/api-testing-standards', type: 'api-testing' },
    { name: 'Mobile Testing Strategy', url: '/docs/mobile-testing-strategy', type: 'mobile' },
    { name: 'CI/CD Integration for QA', url: '/docs/qa-cicd-integration', type: 'ci-cd' }
  ],
  senior: [
    { name: 'QA Strategy and Planning', url: '/docs/qa-strategy', type: 'strategy' },
    { name: 'Quality Metrics Framework', url: '/docs/quality-metrics', type: 'metrics' },
    { name: 'Risk-Based Testing Approach', url: '/docs/risk-based-testing', type: 'risk-management' },
    { name: 'Test Process Improvement', url: '/docs/test-process-improvement', type: 'process-improvement' },
    { name: 'QA Team Leadership Guide', url: '/docs/qa-leadership', type: 'leadership' }
  ]
};
